export interface ITranslationDictionary {
    [key: string]: string;
}

// TODO move to backend
export const Translations: ITranslationDictionary = {
    TITLE: 'Lunchtime',
    SUBTITLE: 'Lass den Zufall entscheiden',
    LOGGED_IN: 'Angemeldet als:',
    APPOINTMENT_SELECT: '1. Termin wählen',
    APPOINTMENT_SELECT_INFO:
        'Wähle einen oder mehrere für Dich passende Termine.',
    MAGIC: '2. Lunchtime Magic',
    MAGIC_INFO:
        'Lunchtime wählt per Zufall die anderen (maximal 4) Kolleg*innen aus, mit denen du essen gehen wirst.',
    ADDITIONAL_VALUE: '3. Neue Kolleg*innen treffen',
    ADDITIONAL_VALUE_INFO:
        'Lunchtime informiert Dich an deinem Lunchtag, mit wem du Dich triffst.',
    CHOOSE_LUNCHDATES: 'Wähle deine Lunchtage',
    CLICK_TO_SELECT: 'Wähle einen Treffpunkt um Dich an- oder abzumelden',
    SUGGESTION_TEXT_1: 'Du brauchst eine Anregung, wo Ihr essen gehen könnt?',
    SUGGESTION_BUTTON_LABEL: 'Zeige mir alle Restaurants in der Umgebung',
    GIVE_FEEDBACK: 'Sag uns deine Meinung',
    THE_TEAM: 'Das Team',
    IMPRINT: 'Impressum',
    HOMEPAGE: 'Homepage',
    FEEDBACK_SENT_THX:
        'Deine Nachricht wurde versendet. Danke für dein Feedback!',
    FEEDBACK_WINDOW_TITLE:
        'Deine Fehlermeldung oder dein Verbesserungsvorschlag',
    FEEDBACK: 'Feedback',
    SEND: 'Senden',
    CANCEL: 'Abbrechen',
    AT_NOON: '12 Uhr',
    AT_AFTERNOON: '13 Uhr',
    SELECT_SUCCESS: 'Erfolgreich angemeldet!',
    REJECT_SUCCESS: 'Erfolgreich abgemeldet!',
};
